import React from "react";
import { cn } from "src/lib/cn";
import Flex from "src/sudokit/Layout/Flex";
import { WithReset } from "src/sudokit/Layout/BoxReset";

interface PanelLayoutProps {
  result: React.ReactNode;
  children: React.ReactNode;
}

const PanelLayout: React.FC<PanelLayoutProps> = ({ result, children }) => (
  <Flex align="flex-start" gap={5} className="flex-col-reverse xl:flex-row-reverse">
    {result}
    <WithReset className={cn("w-full p-4 rounded-xl", "bg-app-menu-color border border-app-menu-color-hover shadow-card")}>
      <div className="flex flex-col items-start gap-6 w-full">{children}</div>
    </WithReset>
  </Flex>
);

export default PanelLayout;
